import React from "react";
import { Helmet } from "react-helmet";
import Layout from "../components/Layoutthree";
import orangeDots from "../images/orangeDots.png";
import respFast from "../images/on-shore.svg";
import scale from "../images/off-shore.svg";
import researchSvg from "../images/research.svg";
import planningSvg from "../images/planning.svg";
import designingSvg from "../images/designing.svg";
import developmentSvg from "../images/development.svg";
import testingSvg from "../images/testing.svg";
import { SEO } from "../components/seo";

const WhatWeDo = () => {
  return (
    <Layout>
      <Helmet title="What We Do" />
      <div className="services">
        <div className="container-fluid">
          <div className="services-top-info container">
            <h6>What We Do</h6>
            <p>
              Custom software development with <br />
              the latest tech
            </p>
          </div>
          <div>
            <div className="what-we-do-img"></div>
            <div className="banner-back">
              <img src={orangeDots} alt="Orange Dots" className="orange-dots" />
            </div>
          </div>
          <div className="web-app-banner">
            <div className="container">
              <div className="row">
                <div className="col-lg-12 col-12">
                  <h4>
                    Concerned about high development or employment costs?
                    Looking for experienced software engineers? Aiming to expand
                    on a global scale? Your search ends here.{" "}
                  </h4>

                  <p className="pe-5 me-5">
                    Deerhold is a global software development and data analytics
                    company based in Boston in the US, with a major subsidiary
                    in Nepal and offices in Qatar, Japan and Singapore. Our
                    strong network of 500+ software engineers spans several
                    countries. This talented collective provides you with an
                    unparalleled range of custom software solutions.
                    <br />
                    <br />
                    Our ever-growing network brings years of experience in all
                    aspects of the IT world. From data analytics to software
                    design and mobile application development – you name it, we
                    do it. What’s more, Deerhold boasts an extensive presence
                    across time zones. This allows for a 24/7 work cycle as well
                    as offshore and on-site development services.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <section className="container section-two">
            <div className="row">
              <div className="col-lg-7 col-12 d-flex flex-column justify-content-center">
                <h4>Holistic Solutions Tailored for Your Business</h4>

                <p className="pe-5">
                  In this fast-paced digital era, companies need many virtual
                  platforms and applications. This creates a need to integrate
                  these elements. We can help you create an integrated digital
                  infrastructure to work better, faster and smarter. Deerhold
                  offers an ever-increasing menu of software services. We are
                  consistently refining our existing skills and cultivating new
                  ones. With our comprehensive capabilities, we craft
                  synergistic software solutions tailored to you.
                </p>
              </div>

              <div className="col-lg-5 col-12">
                <img
                  src="https://dh-uat-website-hosting.s3.amazonaws.com/dh-medias/1676002416889"
                  alt="Gathering"
                />
              </div>
            </div>
          </section>

          <section className="web-app-features container text-center my-5 py-5 px-0">
            <h4>HOW WE WORK</h4>
            <p className="web-app-para text-center px-0 px-lg-5">
              Deerhold stands out in the software development industry because
              of its novel model. We offer malleable software development
              services to adapt to your specific situation. We tailor our
              offshore and on-site development services to you.
            </p>

            <div className="row orange-icon-section">
              <div className="col-lg-6 col-12">
                <img src={respFast} alt="Resposive Fast" />
                <h6 className="fw-bold">
                  Offshore Software Development Services
                </h6>
                <p className="px-5">
                  As a global company, we are well connected across time zones
                  and borders. Our offshore development model allows you to
                  outsource your software development solutions to our engineers
                  in Nepal and elsewhere. There are several advantages to this
                  model. Being nearly half a day ahead of much of the world, our
                  clients enjoy a longer work cycle. Our international workforce
                  also gives us a price-competitive edge. We ensure quick
                  communication, on-time delivery and open communication
                  channels. Outsourcing has never been easier!
                </p>
              </div>
              <div className="col-lg-6 col-12">
                <img src={scale} alt="Scalable" />
                <h6 className="fw-bold">
                  On-site Software Development Services
                </h6>
                <p className="px-5">
                  For clients that prefer a physical team, we present an equally
                  competent on-site software development model. Here, we assign
                  a team of software engineers that would work out of your
                  office. This model is ideal for long-term projects that would
                  benefit from an on-site team.
                </p>
              </div>
            </div>
          </section>
        </div>
      </div>

      <section className="how-we-work py-5">
        <div className="container">
          <div className="section-title">Our Process</div>

          <div className="how-work d-flex align-items-start mt-5 d-lg-flex d-none">
            <div
              className="nav flex-column nav-pills me-3"
              id="v-pills-tab"
              role="tablist"
              aria-orientation="vertical"
            >
              <button
                className="nav-link active"
                id="v-pills-research-tab"
                data-bs-toggle="pill"
                data-bs-target="#v-pills-research"
                type="button"
                role="tab"
                aria-controls="v-pills-research"
                aria-selected="true"
              >
                <span>
                  <img src={researchSvg} alt="Research" className="btn-icon" />
                </span>
                PROJECT DISCOVERY
              </button>
              <button
                className="nav-link"
                id="v-pills-planning-tab"
                data-bs-toggle="pill"
                data-bs-target="#v-pills-planning"
                type="button"
                role="tab"
                aria-controls="v-pills-planning"
                aria-selected="false"
              >
                <span>
                  <img src={planningSvg} alt="Research" className="btn-icon" />
                </span>
                DESIGN AND DEVELOP
              </button>
              <button
                className="nav-link"
                id="v-pills-designing-tab"
                data-bs-toggle="pill"
                data-bs-target="#v-pills-designing"
                type="button"
                role="tab"
                aria-controls="v-pills-designing"
                aria-selected="false"
              >
                <span>
                  <img src={designingSvg} alt="Research" className="btn-icon" />
                </span>
                RELEASE / DELIVER / ENHANCE
              </button>
              {/* <button
                className="nav-link"
                id="v-pills-development-tab"
                data-bs-toggle="pill"
                data-bs-target="#v-pills-development"
                type="button"
                role="tab"
                aria-controls="v-pills-development"
                aria-selected="false"
              >
                <span>
                  <img
                    src={developmentSvg}
                    alt="Research"
                    className="btn-icon"
                  />
                </span>
                Development
              </button>
              <button
                className="nav-link"
                id="v-pills-testing-tab"
                data-bs-toggle="pill"
                data-bs-target="#v-pills-testing"
                type="button"
                role="tab"
                aria-controls="v-pills-testing"
                aria-selected="false"
              >
                <span>
                  <img src={testingSvg} alt="Research" className="btn-icon" />
                </span>
                Testing
              </button> */}
            </div>
            <div className="tab-content" id="v-pills-tabContent">
              <div
                className="tab-pane fade show active"
                id="v-pills-research"
                role="tabpanel"
                aria-labelledby="v-pills-research-tab"
              >
                <p>
                  Before discussing requirements with clients, we nosedive into
                  the business’ understanding and the nature of the project.
                  During the initial call, you’ll tell us the details of your
                  project and exactly what you’d like to have accomplished.
                  Whether you need a full team or a couple of developers, we’ll
                  work together to identify which roles you’ll need filling for
                  what duration of time. We create high-fidelity wireframes and
                  share effort estimates & schedules, along with the required
                  documentation.
                </p>
              </div>
              <div
                className="tab-pane fade"
                id="v-pills-planning"
                role="tabpanel"
                aria-labelledby="v-pills-planning-tab"
              >
                <p>
                  Our business analysts will help to identify the right features
                  and core software functionality. To ensure that the Agile
                  project stays on track, the requirements for each iteration
                  are taken from the prioritized list in the backlog. The
                  Product Owner is responsible for organizing the backlog, with
                  the most important items at the top. The team then selects
                  items from the top of the list to work on in the current
                  sprint. All the stories picked for the sprint go through the
                  Plan - Design - Develop - QA - Review cycle to ensure new
                  features and functionalities are implemented according to
                  customer requirements. We implement a mix of proven practices,
                  including prioritized product backlogging, rapid prototyping,
                  documentation testing, iterative and incremental development,
                  TDD, extreme programming, and modern SQA techniques to enable
                  fast and efficient ongoing product delivery.
                </p>
              </div>
              <div
                className="tab-pane fade"
                id="v-pills-designing"
                role="tabpanel"
                aria-labelledby="v-pills-designing-tab"
              >
                <p>
                  We use Continuous Integration and Continuous Delivery to
                  ensure that the right functionality is released at the right
                  time, and in accordance with quality standards. The product
                  can be implemented with feature toggling or A/B testing
                  techniques for more complex scenarios. This provides an
                  efficient way to assess how new features are impacting the
                  end-user experience. After the project delivery(go-live), we
                  continue to provide product support and maintenance. Our
                  clients will receive 30 days of complimentary support
                  following the go-live. Ultimately, we want to support your
                  business as it grows. We welcome clients who wish to continue
                  working with the same team on new ideas or want to expand the
                  project based on user feedback.
                </p>
              </div>
              {/* <div
                className="tab-pane fade"
                id="v-pills-development"
                role="tabpanel"
                aria-labelledby="v-pills-development-tab"
              >
                <p>
                  Deerhold consists of a large team of developers who are
                  skilled in bringing client requirements and initial designs to
                  sustainable real-world applications. We follow professional
                  standards during the coding process in all our projects. Agile
                  methodology is followed during the development. This leads to
                  consistent meetings among the development team and clients for
                  addressing any changes in initial requirements. It also leads
                  to a better overall final product.
                </p>
              </div>
              <div
                className="tab-pane fade"
                id="v-pills-testing"
                role="tabpanel"
                aria-labelledby="v-pills-testing-tab"
              >
                <p>
                  Deerhold has a separate team for Quality Assurance and Quality
                  Control. They perform various tests on the product to check
                  for errors and gaps and whether the outcome of the application
                  matches desired expectations before the software is installed
                  and goes live. This increases the overall quality of the
                  product. We have a rigorous testing process before the
                  production of any product so that only high-quality
                  applications are delivered to our clients.
                </p>
              </div> */}
            </div>
          </div>

          <div
            className="accordion mt-5 d-lg-none d-block"
            id="accordionExample"
          >
            <div className="accordion-item">
              <h2 className="accordion-header" id="headingOne">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#researchAccordian"
                  aria-expanded="false"
                  aria-controls="researchAccordian"
                >
                  <span>
                    <img
                      src={researchSvg}
                      alt="Research"
                      className="btn-icon"
                    />
                  </span>
                  PROJECT DISCOVERY
                </button>
              </h2>
              <div
                id="researchAccordian"
                className="accordion-collapse collapse"
                aria-labelledby="headingOne"
                data-bs-parent="#accordionExample"
              >
                <div className="accordion-body">
                  Before discussing requirements with clients, we nosedive into
                  the business’ understanding and the nature of the project.
                  During the initial call, you’ll tell us the details of your
                  project and exactly what you’d like to have accomplished.
                  Whether you need a full team or a couple of developers, we’ll
                  work together to identify which roles you’ll need filling for
                  what duration of time. We create high-fidelity wireframes and
                  share effort estimates & schedules, along with the required
                  documentation.
                </div>
              </div>
            </div>
            <div className="accordion-item">
              <h2 className="accordion-header" id="headingTwo">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#planningAccordian"
                  aria-expanded="false"
                  aria-controls="planningAccordian"
                >
                  <img src={planningSvg} alt="planning" className="btn-icon" />
                  <span>DESIGN and DEVELOP</span>
                </button>
              </h2>
              <div
                id="planningAccordian"
                className="accordion-collapse collapse"
                aria-labelledby="headingTwo"
                data-bs-parent="#accordionExample"
              >
                <div className="accordion-body">
                  Our business analysts will help to identify the right features
                  and core software functionality. To ensure that the Agile
                  project stays on track, the requirements for each iteration
                  are taken from the prioritized list in the backlog. The
                  Product Owner is responsible for organizing the backlog, with
                  the most important items at the top. The team then selects
                  items from the top of the list to work on in the current
                  sprint. All the stories picked for the sprint go through the
                  Plan - Design - Develop - QA - Review cycle to ensure new
                  features and functionalities are implemented according to
                  customer requirements. We implement a mix of proven practices,
                  including prioritized product backlogging, rapid prototyping,
                  documentation testing, iterative and incremental development,
                  TDD, extreme programming, and modern SQA techniques to enable
                  fast and efficient ongoing product delivery.
                </div>
              </div>
            </div>
            <div className="accordion-item">
              <h2 className="accordion-header" id="headingThree">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#designingAccordian"
                  aria-expanded="false"
                  aria-controls="designingAccordian"
                >
                  <img
                    src={designingSvg}
                    alt="Designing"
                    className="btn-icon"
                  />
                  <span>RELEASE / DELIVER / ENHANCE</span>
                </button>
              </h2>
              <div
                id="designingAccordian"
                className="accordion-collapse collapse"
                aria-labelledby="headingThree"
                data-bs-parent="#accordionExample"
              >
                <div className="accordion-body">
                  We use Continuous Integration and Continuous Delivery to
                  ensure that the right functionality is released at the right
                  time, and in accordance with quality standards. The product
                  can be implemented with feature toggling or A/B testing
                  techniques for more complex scenarios. This provides an
                  efficient way to assess how new features are impacting the
                  end-user experience. After the project delivery(go-live), we
                  continue to provide product support and maintenance. Our
                  clients will receive 30 days of complimentary support
                  following the go-live. Ultimately, we want to support your
                  business as it grows. We welcome clients who wish to continue
                  working with the same team on new ideas or want to expand the
                  project based on user feedback.
                </div>
              </div>
            </div>
            {/* <div className="accordion-item">
              <h2 className="accordion-header" id="headingThree">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#developAccordian"
                  aria-expanded="false"
                  aria-controls="developAccordian"
                >
                  <img
                    src={developmentSvg}
                    alt="Research"
                    className="btn-icon"
                  />
                  <span>Development</span>
                </button>
              </h2>
              <div
                id="developAccordian"
                className="accordion-collapse collapse"
                aria-labelledby="headingThree"
                data-bs-parent="#accordionExample"
              >
                <div className="accordion-body">
                  Deerhold consists of a large team of developers who are
                  skilled in bringing client requirements and initial designs to
                  sustainable real-world applications. We follow professional
                  standards during the coding process in all our projects. Agile
                  methodology is followed during the development. This leads to
                  consistent meetings among the development team and clients for
                  addressing any changes in initial requirements. It also leads
                  to a better overall final product.
                </div>
              </div>
            </div>
            <div className="accordion-item">
              <h2 className="accordion-header" id="headingThree">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#testingAccordian"
                  aria-expanded="false"
                  aria-controls="testingAccordian"
                >
                  <img src={testingSvg} alt="Research" className="btn-icon" />
                  <span>Testing</span>
                </button>
              </h2>
              <div
                id="testingAccordian"
                className="accordion-collapse collapse"
                aria-labelledby="headingThree"
                data-bs-parent="#accordionExample"
              >
                <div className="accordion-body">
                  Deerhold has a separate team for Quality Assurance and Quality
                  Control. They perform various tests on the product to check
                  for errors and gaps and whether the outcome of the application
                  matches desired expectations before the software is installed
                  and goes live. This increases the overall quality of the
                  product. We have a rigorous testing process before the
                  production of any product so that only high-quality
                  applications are delivered to our clients.
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default WhatWeDo;

export const Head = () => (
  <SEO
    title="Deerhold: What We Do"
    description="Concerned about high development or employment costs? Looking for experienced software engineers? Aiming to expand on a global scale? Your search ends here."
    keywords="Experienced Software Engineers, Hoslitic Solutions, Novel Model, Offshore software development services, onsite software deve;opment services, price competitive, project discovery, design and develop, release, deliver, enhance, A/B Testing, CI/CD"
    pathname="/what-we-do"
    image="/DeerholdOG.jpg"
  />
);
